"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMeteorPostMessenger = void 0;
var nanoid_1 = require("nanoid");
var envConfig_1 = require("../envConfig");
var ExternalActionTypes_1 = require("../../../meteor-common/src/models/external_actions/ExternalActionTypes");
var query_string_1 = require("query-string");
var ExternalActionErrorMessages_1 = require("../../../meteor-common/src/models/external_actions/ExternalActionErrorMessages");
var app_constants_1 = require("../../../meteor-common/src/constants/app_constants");
var ComWindow = /*#__PURE__*/function () {
  function ComWindow(connection, listener) {
    _classCallCheck(this, ComWindow);
    var baseWalletUrl = envConfig_1.envConfig.wallet_base_url;
    var url = new URL(baseWalletUrl);
    this.walletOrigin = url.origin;
    if (window.meteorCom == null) {
      this.comType = ExternalActionTypes_1.EMeteorWalletExternalActionSource.website_post_message;
      console.log("No extension found. Need to connect to web popup for Meteor communication");
      var queryParams = {
        source: ExternalActionTypes_1.EMeteorWalletExternalActionSource.website_post_message,
        connectionUid: connection.uid
      };
      var w = app_constants_1.SIGN_POPUP_WIDTH;
      var h = app_constants_1.SIGN_POPUP_HEIGHT;
      var y = window.top.outerHeight / 2 + window.top.screenY - h / 2;
      var x = window.top.outerWidth / 2 + window.top.screenX - w / 2;
      var newWindow = window.open("".concat(baseWalletUrl, "/connect/").concat(connection.network, "/").concat(connection.actionType, "?").concat((0, query_string_1.stringify)(queryParams)), "_blank", "popup=1,width=".concat(w, ",height=").concat(h, ",top=").concat(y, ",left=").concat(x));
      if (newWindow != null) {
        this.websiteWindow = newWindow;
      } else {
        throw new ExternalActionTypes_1.MeteorActionError({
          message: "Couldn't open popup window to complete wallet action",
          endTags: [ExternalActionErrorMessages_1.EMeteorActionErrorTag.POPUP_WINDOW_OPEN_FAILED]
        });
      }
      window.addEventListener("message", function (event) {
        return listener(event.data);
      });
      this.wasOpened = false;
    } else {
      this.comType = ExternalActionTypes_1.EMeteorWalletExternalActionSource.extension_injected;
      this.wasOpened = true;
      // console.log("Need to communicate with the extension!");
      window.meteorCom.addMessageDataListener(listener);
    }
  }
  _createClass(ComWindow, [{
    key: "focus",
    value: function focus() {
      var _a;
      if (this.comType === ExternalActionTypes_1.EMeteorWalletExternalActionSource.website_post_message) {
        (_a = this.websiteWindow) === null || _a === void 0 ? void 0 : _a.focus();
      }
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(data) {
      var _a, _b;
      if (this.comType === ExternalActionTypes_1.EMeteorWalletExternalActionSource.website_post_message) {
        (_a = this.websiteWindow) === null || _a === void 0 ? void 0 : _a.postMessage(data, this.walletOrigin);
      } else {
        (_b = window.meteorCom) === null || _b === void 0 ? void 0 : _b.sendMessageData(data);
      }
    }
  }, {
    key: "isWindowClosed",
    value: function isWindowClosed() {
      var _a, _b;
      if (this.comType === ExternalActionTypes_1.EMeteorWalletExternalActionSource.website_post_message) {
        return (_b = (_a = this.websiteWindow) === null || _a === void 0 ? void 0 : _a.closed) !== null && _b !== void 0 ? _b : true;
      } else {
        return false;
      }
    }
  }, {
    key: "hasActiveWindow",
    value: function hasActiveWindow() {
      if (this.comType === ExternalActionTypes_1.EMeteorWalletExternalActionSource.website_post_message) {
        return this.websiteWindow != null;
      } else {
        return true;
      }
    }
  }, {
    key: "close",
    value: function close() {
      if (this.comType === ExternalActionTypes_1.EMeteorWalletExternalActionSource.website_post_message) {
        delete this.websiteWindow;
      } else {}
    }
  }]);
  return ComWindow;
}();
var pingInterval = 450;
var MeteorPostMessenger = /*#__PURE__*/function () {
  function MeteorPostMessenger() {
    var _this = this;
    _classCallCheck(this, MeteorPostMessenger);
    this.connections = [];
    // const baseUrl = "https://dev.wallet.meteorwallet.app";
    var baseUrl = envConfig_1.envConfig.wallet_base_url;
    var url = new URL(baseUrl);
    this.baseWalletUrl = baseUrl;
    this.walletOrigin = url.origin;
    this.listener = function (data) {
      if (data != null) {
        // const data: TClientPostMessageResponse = event.data;
        // console.log("Meteor Post Messenger received event with data: ", data);
        var currentConnection = _this.connections.find(function (con) {
          return con.uid === data.uid;
        });
        if (currentConnection != null) {
          _this.updateConnection(currentConnection.uid, {
            lastConnection: Date.now()
          });
          if (data.status === ExternalActionTypes_1.EExternalActionConnectionStatus.attempting_reconnect) {
            _this.updateConnection(currentConnection.uid, {
              status: ExternalActionTypes_1.EExternalActionConnectionStatus.initializing
            });
            _this.sendComs();
          }
          if (data.status === ExternalActionTypes_1.EExternalActionConnectionStatus.connected && currentConnection.status === ExternalActionTypes_1.EExternalActionConnectionStatus.initializing) {
            _this.updateConnection(currentConnection.uid, {
              status: ExternalActionTypes_1.EExternalActionConnectionStatus.connected
            });
          }
          if (data.status === ExternalActionTypes_1.EExternalActionConnectionStatus.closed_success) {
            currentConnection.resolve({
              success: true,
              endTags: [],
              payload: data.payload
            });
            _this.updateConnection(currentConnection.uid, {
              status: ExternalActionTypes_1.EExternalActionConnectionStatus.closed_success
            });
            _this.sendComs();
          }
          if (data.status === ExternalActionTypes_1.EExternalActionConnectionStatus.closed_fail) {
            _this.updateConnection(currentConnection.uid, {
              status: ExternalActionTypes_1.EExternalActionConnectionStatus.closed_fail
            });
            _this.sendComs();
            // const error = new MeteorActionError({ endTags: data.endTags });
            // console.log("Ending failure with error", { ...error });
            currentConnection.reject(new ExternalActionTypes_1.MeteorActionError({
              endTags: data.endTags
            }));
          }
          if (data.status === ExternalActionTypes_1.EExternalActionConnectionStatus.closed_window) {
            _this.updateConnection(currentConnection.uid, {
              status: ExternalActionTypes_1.EExternalActionConnectionStatus.closed_window
            });
            currentConnection.reject(new ExternalActionTypes_1.MeteorActionError({
              endTags: data.endTags,
              message: "User closed the window"
            }));
          }
          if ([ExternalActionTypes_1.EExternalActionConnectionStatus.disconnected, ExternalActionTypes_1.EExternalActionConnectionStatus.closed_fail, ExternalActionTypes_1.EExternalActionConnectionStatus.closed_window, ExternalActionTypes_1.EExternalActionConnectionStatus.closed_success].includes(data.status)) {
            _this.removeConnection(currentConnection.uid);
          }
        } /* else {
          console.warn(`Connection data received but no ID found "${data.uid}"`, data);
          }*/
      }
    };
    // window.addEventListener("message", this.listener);
  }
  _createClass(MeteorPostMessenger, [{
    key: "removeConnection",
    value: function removeConnection(uid) {
      this.connections = this.connections.filter(function (con) {
        return con.uid !== uid;
      });
      if (this.connections.length === 0) {
        delete this.comWindow;
        clearInterval(this.comInterval);
        delete this.comInterval;
      }
    }
  }, {
    key: "updateConnection",
    value: function updateConnection(uid, newConnectionProperties) {
      this.connections = this.connections.map(function (con) {
        if (con.uid === uid) {
          return _objectSpread(_objectSpread(_objectSpread({}, con), newConnectionProperties), {}, {
            uid: con.uid
          });
        }
        return con;
      });
    }
  }, {
    key: "sendComs",
    value: function sendComs() {
      var _this2 = this;
      var _a;
      if (((_a = this.comWindow) === null || _a === void 0 ? void 0 : _a.hasActiveWindow()) && this.connections.length > 0) {
        if (this.comInterval == null) {
          this.comInterval = setInterval(function () {
            return _this2.sendComs();
          }, pingInterval);
        }
        if (this.comWindow.isWindowClosed()) {
          if (this.comWindow.wasOpened) {
            var _iterator = _createForOfIteratorHelper(this.connections),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var con = _step.value;
                con.reject(new ExternalActionTypes_1.MeteorActionError({
                  message: "User closed the window before completing the action",
                  endTags: [ExternalActionErrorMessages_1.EMeteorActionErrorTag.INCOMPLETE_ACTION, ExternalActionErrorMessages_1.EMeteorActionErrorTag.WINDOW_CLOSED]
                }));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            this.connections = [];
            this.comWindow.close();
          } else {
            console.log("Window is closed, need to allow popup");
          }
        } else {
          this.comWindow.wasOpened = true;
          var _iterator2 = _createForOfIteratorHelper(this.connections),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _step2$value = _step2.value,
                network = _step2$value.network,
                actionType = _step2$value.actionType,
                endTags = _step2$value.endTags,
                status = _step2$value.status,
                inputs = _step2$value.inputs,
                uid = _step2$value.uid;
              var postMessage = {
                endTags: endTags,
                actionType: actionType,
                status: status,
                uid: uid,
                network: network
              };
              if (status === ExternalActionTypes_1.EExternalActionConnectionStatus.initializing) {
                postMessage.inputs = inputs;
              }
              this.comWindow.sendMessage(postMessage);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } else {
        clearInterval(this.comInterval);
        delete this.comInterval;
      }
    }
  }, {
    key: "addAndStartConnection",
    value: function addAndStartConnection(connection) {
      if (this.connections.length > 0) {
        var _iterator3 = _createForOfIteratorHelper(this.connections),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var con = _step3.value;
            con.status = ExternalActionTypes_1.EExternalActionConnectionStatus.disconnected;
            con.endTags = [ExternalActionErrorMessages_1.EMeteorActionErrorTag.NEW_ACTION_STARTED];
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      this.connections.push(connection);
      if (this.comWindow == null || !this.comWindow.hasActiveWindow()) {
        this.comWindow = new ComWindow(connection, this.listener);
      } else {
        this.comWindow.focus();
      }
      this.sendComs();
    }
  }, {
    key: "connectAndWaitForResponse",
    value: function () {
      var _connectAndWaitForResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var _this3 = this;
        var actionType, network, inputs, newConnection, promise;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              actionType = _ref.actionType, network = _ref.network, inputs = _ref.inputs;
              newConnection = {
                uid: (0, nanoid_1.nanoid)(),
                actionType: actionType,
                lastAttemptedConnection: 0,
                lastConnection: 0,
                status: ExternalActionTypes_1.EExternalActionConnectionStatus.initializing,
                promise: undefined,
                reject: undefined,
                resolve: undefined,
                currentPayload: {},
                inputs: inputs,
                network: network,
                endTags: []
              };
              promise = new Promise(function (resolve, reject) {
                newConnection.resolve = resolve;
                newConnection.reject = function (error) {
                  _this3.connections = _this3.connections.filter(function (con) {
                    return con.uid !== newConnection.uid;
                  });
                  reject(error);
                };
              });
              newConnection.promise = promise;
              this.addAndStartConnection(newConnection);
              _context.next = 7;
              return promise;
            case 7:
              return _context.abrupt("return", _context.sent);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connectAndWaitForResponse(_x) {
        return _connectAndWaitForResponse.apply(this, arguments);
      }
      return connectAndWaitForResponse;
    }()
  }]);
  return MeteorPostMessenger;
}();
var postMessenger;
function getMeteorPostMessenger() {
  if (postMessenger == null) {
    postMessenger = new MeteorPostMessenger();
  }
  return postMessenger;
}
exports.getMeteorPostMessenger = getMeteorPostMessenger;